import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstOfg: [],
        ofg: null,
        pr0: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        pending: false,
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getOfg(state) {
            let ofg = { ...state.ofg }
            return ofg
        },
        getOfgmotivo(state) {
            return state.ofg.ofgmotivo
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, ofg) {
            state.ofg = ofg
            if (ofg)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.ofg = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOfg = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOfg(state, ofg) {
            state.ofg = ofg
        },
        setLstOfg(state, lstOfg) {
            state.lstOfg = lstOfg
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, ofgmotivo) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/ReasonNonConforming/Find/${ofgmotivo}`)
                .then(response => {
                    let ofg = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofg)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Products/ReasonNonConforming/Insert", getters.getOfg)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setOfg", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Products/ReasonNonConforming/Update", getters.getOfg)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Products/ReasonNonConforming/Delete/${getters.getOfgmotivo}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/peca-nao-conforme")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/ReasonNonConforming/FindList`, getters.getOfg)
                .then(response => {
                    let lstOfg = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstOfg", lstOfg)
                    commit("setHasNext", lstOfg.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstOfg", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/ReasonNonConforming/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstOfg", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
    }
}